module.exports = __webpack_public_path__ + "assets/images/premium-features/unavailability-2-ecac97.svg";